import React from 'react';
import { Role } from '../chat-item/ChatItem';
import { ChatBubble } from '../chat-bubble/ChatBubble';

interface ChatBubbleGroupProps {
  role: Role;
  text: string;
  translatedText?: string;
  isHideOriginal?: boolean;
  isRmTranslationsEnabled?: boolean;
}

export const ChatBubbleGroup = ({
  role,
  text,
  translatedText,
  isHideOriginal = false,
  isRmTranslationsEnabled = false,
}: ChatBubbleGroupProps) => {
  const isAgent = role === Role.Agent;

  const originalBubble = !isHideOriginal ? (
    <ChatBubble
      role={role}
      text={text}
      isOrginalMessage={translatedText ? true : false}
      isRmTranslationsEnabled={isRmTranslationsEnabled}
    />
  ) : null;
  const translatedBubble =
    translatedText && isRmTranslationsEnabled ? (
      <ChatBubble role={role} text={translatedText} isTranslated />
    ) : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {isAgent ? (
        <>
          {originalBubble}
          {translatedBubble}
        </>
      ) : (
        <>
          {translatedBubble}
          {originalBubble}
        </>
      )}
    </div>
  );
};
